import React, { useState } from 'react';
import './App.css';

function App() {
  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');
  const [bmi, setBMI] = useState(null);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  const calculateBMI = () => {
    // 입력값 확인
    if (!height || !weight) {
      setError('키와 몸무게를 모두 입력해주세요.');
      setBMI(null);
      setStatus('');
      return;
    }

    // 숫자 변환
    const heightInM = parseFloat(height) / 100;
    const weightInKg = parseFloat(weight);

    // 유효성 검사
    if (heightInM <= 0 || weightInKg <= 0) {
      setError('키와 몸무게는 양수여야 합니다.');
      setBMI(null);
      setStatus('');
      return;
    }

    // BMI 계산: 체중(kg) / 키(m)²
    const bmiValue = weightInKg / (heightInM * heightInM);
    setBMI(bmiValue.toFixed(2));
    setError('');

    // BMI 상태 결정
    if (bmiValue < 18.5) {
      setStatus('저체중');
    } else if (bmiValue < 23) {
      setStatus('정상');
    } else if (bmiValue < 25) {
      setStatus('과체중');
    } else if (bmiValue < 30) {
      setStatus('비만');
    } else {
      setStatus('고도비만');
    }
  };

  const resetForm = () => {
    setHeight('');
    setWeight('');
    setBMI(null);
    setStatus('');
    setError('');
  };

  // BMI 상태에 따른 클래스 결정
  const getStatusClass = () => {
    switch (status) {
      case '저체중':
        return 'status-underweight';
      case '정상':
        return 'status-normal';
      case '과체중':
        return 'status-overweight';
      case '비만':
        return 'status-obese';
      case '고도비만':
        return 'status-severely-obese';
      default:
        return '';
    }
  };

  return (
    <div className="app-container">
      <div className="app-header">
        체질량 지수(BMI) 계산기
      </div>
      
      <div className="form-container">
        <div className="input-group">
          <label htmlFor="height">키 (cm)</label>
          <input
            id="height"
            type="number"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            className="input-field"
            placeholder="키를 입력하세요 (예: 170)"
          />
        </div>
        
        <div className="input-group">
          <label htmlFor="weight">몸무게 (kg)</label>
          <input
            id="weight"
            type="number"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            className="input-field"
            placeholder="몸무게를 입력하세요 (예: 65)"
          />
        </div>
        
        <div className="buttons-container">
          <button
            onClick={calculateBMI}
            className="button button-primary"
          >
            계산하기
          </button>
          <button
            onClick={resetForm}
            className="button button-secondary"
          >
            초기화
          </button>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        {bmi && (
          <div className="result-container">
            <div className="result-title">결과</div>
            <div className="result-item">
              BMI 지수: <span className="result-value">{bmi}</span>
            </div>
            <div className="result-item">
              상태: <span className={`result-value ${getStatusClass()}`}>{status}</span>
            </div>
            
            <div className="bmi-info">
              <p>BMI 기준 (아시아/한국 기준):</p>
              <ul>
                <li><span>저체중</span> <span>18.5 미만</span></li>
                <li><span>정상</span> <span>18.5 ~ 22.9</span></li>
                <li><span>과체중</span> <span>23 ~ 24.9</span></li>
                <li><span>비만</span> <span>25 ~ 29.9</span></li>
                <li><span>고도비만</span> <span>30 이상</span></li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;